import {useFormContext} from 'react-hook-form';
import Trash from 'src/components/ui-icons/buttons/Trash';
import {FC} from 'react';
import {IAnswer, QUESTION_TYPES} from '../../types';
import CustomCheckbox from '../../components/Ui/CustomCheckbox';
import CustomRadio from '../../components/Ui/CustomRadio';

export interface IProps {
  index: number;
  id: string;
  answer: IAnswer;
}

const AnswerField: FC<IProps> = ({index, id, answer}) => {
  const {register, watch, setValue} = useFormContext();
  const questionType = watch('Type');
  const answers = watch('Answers');
  const isQuestionTypeMultiple = questionType === QUESTION_TYPES.MULTIPLE;
  const CustomInput = isQuestionTypeMultiple ? CustomCheckbox : CustomRadio;

  const handleDeleteAnswerClick = () => {
    const updatedAnswers = answers.filter((answer: IAnswer) => answer.ID !== id);
    setValue('Answers', updatedAnswers, {shouldValidate: true, shouldDirty: true});
  };

  const handleChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updateAnswers = answers.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: e.target.id === answer.ID ? !answer.IsCorrect : answer.IsCorrect
    }));
    setValue('Answers', updateAnswers, {shouldValidate: true, shouldDirty: true});
  };

  const handleChangeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updateAnswers = answers.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: e.target.id === answer.ID ? 'on' : null
    }));
    setValue('Answers', updateAnswers, {shouldValidate: true, shouldDirty: true});
  };

  return (
    <div>
      <div className="flex mb-5">
        <div className="w-full mr-6">
          <div className="flex justify-between">
            <h3 className="mb-[10px] text-base text-black font-medium">Вариант ответа</h3>
            <span className="text-red text-base font-bold">*</span>
          </div>
          <input
            {...register(`Answers.${index}.Description`, {required: true})}
            className="w-full rounded-md shadow-custom p-[11px] border-[#DFE4EA]"
            type="text"
            placeholder="Введите вариант ответа"
          />
        </div>

        <div className="flex items-end">
          <label className="hover:cursor-pointer bg-white flex gap-[10px] rounded-md shadow-custom p-[14px] mr-5 items-center cursor-pointer select-none text-dark dark:text-white">
            <CustomInput {...register(`Answers.${index}.ID`)} id={id} onChange={isQuestionTypeMultiple ? handleChangeCheckBox : handleChangeRadio} checked={answer.IsCorrect}>
              Правильный ответ
            </CustomInput>
          </label>
          <button onClick={handleDeleteAnswerClick} className="bg-white rounded-md shadow-custom p-[14px] hover:cursor-pointer">
            <Trash />
          </button>
        </div>
      </div>
    </div>
  );
};
export default AnswerField;
